// src/utils/filters.js
export const formatStatus = (status) => {
    const map = {
            '0': '校验失败',
            '1': '校验成功',
            '2': '短信失败',
            '3': '短信成功',
            '7': '短信发送',
            '4': '回填失败',
            '5': '回填成功',
            '6': '用户回填',
            '8': '系统拦截',
           '-1': '订购失败',
           '-2': '用户取消',
           '-3': '用户退订',
            '9': '订购成功'
            }
    const key = String(status); // 统一转为字符串避免类型问题0
    if (!map.hasOwnProperty(key)) {
        console.warn(`Unknown status code: ${status}`);
    }

    return map[key] || '未知状态';
};

export const formatFileIcon = (fileName) => {
    try {
        var name = fileName.toLowerCase();
        if (name.indexOf(".xlsx") > 0 || name.indexOf(".xls") > 0) {
            return require("@/assets/icon/excel.png");
        }
        if (name.indexOf(".pdf") > 0) {
            return require("@/assets/icon/pdf.png");
        }
        if (name.indexOf(".word") > 0 || name.indexOf(".doc") > 0 || name.indexOf(".docx") > 0) {
            return require("@/assets/icon/word.png");
        }
        if (name.indexOf(".jfif") > 0 || name.indexOf(".png") > 0 || name.indexOf(".jfif") > 0 || name.indexOf(".jpg") > 0 || name.indexOf(".jpeg") > 0 || name.indexOf(".gif") > 0) {
            return require("@/assets/icon/img.png");
        }
        if(name.indexOf(".txt") > 0) {
            return require("@/assets/icon/txt.png");
        }
        if(name.indexOf(".ppt") > 0 || name.indexOf(".pptx") > 0) {
            return require("@/assets/icon/ppt.png");
        }
        if(name.indexOf(".zip") > 0 || name.indexOf(".tar") > 0 || name.indexOf(".rar") > 0 || name.indexOf(".7z") > 0 || name.indexOf(".iso") > 0) {
            return require("@/assets/icon/zip.png");
        }
        if(name.indexOf(".avi") > 0 || name.indexOf(".mp4")>0 || name.indexOf(".mov") > 0 || name.indexOf(".mkv") > 0 || name.indexOf(".wmv") > 0 || name.indexOf(".plv") > 0 || name.indexOf(".mpeg") > 0 || name.indexOf(".webm") > 0) {
            return require("@/assets/icon/video.png");
        }
        if(name.indexOf(".amr") > 0 || name.indexOf(".w4a") > 0 || name.indexOf(".awb") > 0 || name.indexOf(".mp3") > 0 || name.indexOf(".wav") > 0 || name.indexOf(".flac") > 0 || name.indexOf(".aac") > 0 || name.indexOf(".cgg") > 0 || name.indexOf(".aiff") > 0) {
            return require("@/assets/icon/radio.png");
        }
        return require("@/assets/icon/file.png");
    } catch (e) {
        console.error("加载图标失败:", e);
        return require("@/assets/icon/file.png");
    }
};

